const PrimeTag = () => (
  <span className="primeTag">
    Prime
  </span>
);

export default PrimeTag;
